import {Component} from '@angular/core';
import {FieldType, FieldTypeConfig, FormlyModule} from '@ngx-formly/core';
import {AlertController, IonItem, IonList, IonRadio, IonRadioGroup, IonText} from '@ionic/angular/standalone';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FormlySelectModule} from '@ngx-formly/core/select';

@Component({
  selector: 'string-formly-type',
  template: `
    <ion-item style="cursor: unset; --background-hover-opacity: 0;" lines="full">
      <div style="width: 100%; padding-top: 8px;">
        <ion-text [color]="showError && formControl.errors ? 'danger': ''">
          {{ props.label }}
          <ion-text color="medium">
            @if (!props.required) {
              <small>(Optional)</small>
            }
          </ion-text>
          @if (props.description) {
            <button style="background: none; margin-left: 8px;" (click)="showInfo()">ⓘ</button>
          }
        </ion-text>

        <ion-radio-group [allowEmptySelection]="true" #ionRadioGroup [formControl]="formControl"
                         [formlyAttributes]="field"
                         [id]="String(field.key)" [attr.data-testid]="field.key" [attr.data-label]="props.label">
          <ion-list style="padding-top: 8px; padding-bottom: 8px;" lines="none">
            @for (option of props.options | formlySelectOptions : field | async; track option) {
              <ion-item>
                <ion-radio #ionRadio [style]="{opacity: ionRadioGroup.value === ionRadio.value ? 1 : 0.6}"
                           style="color: var(--ion-color-medium);" [value]="option.value"
                           [attr.value]="option.value" [attr.data-testid]="field.key + '_' + option.value">
                  {{ option.label }}
                </ion-radio>
              </ion-item>
            }
          </ion-list>

        </ion-radio-group>
      </div>
    </ion-item>
  `,
  imports: [CommonModule, TranslateModule, FormlyModule, ReactiveFormsModule, FormlySelectModule, IonRadio, IonItem, IonList, IonRadioGroup, IonText]
})
export class RadioFormlyType extends FieldType<FieldTypeConfig> {

  public constructor(private alertController: AlertController) {
    super();
  }

  public showInfo() {
    this.alertController.create({
      header: 'Info',
      message: this.props.description,
      buttons: ['OK']
    }).then(alert => alert.present());
  }

  protected readonly String = String;
}
